import {WakeletHeader} from "../wakelet-header/WakeletHeader";
import {UserCard} from "./UserCard";
import {AuthProviderType} from "../../domain/providers";
import {Text} from "@wakelet/ui-kit";
import {ContinueWithAuthProvider} from "./ContinueWithAuthProvider";
import {Navigate, useLocation, useSearchParams} from "react-router-dom";
import {useFirstSignInMethod} from "./useFirstSignInMethod";
import {Spinner} from "../loading/Spinner";
import {translateKey} from "../language/translate";
import { useEffect } from "react";
import { AccountsAPI } from "../../accounts-api/accounts-api";
import { signInWithCustomToken } from "../../firebase";

type ExistingUserCardProps = {
  email: string;
  displayName?: string;
  testId?: string;
  continueMessage?: string;
}

export const ExistingUserCard = ({email, displayName, continueMessage}: ExistingUserCardProps) => {
  const location = useLocation();
  const [params] = useSearchParams();
  const {isLoading, isError, signInMethod} = useFirstSignInMethod(email);
  useEffect(() => {
    if (isError || isLoading || signInMethod || !email) {
      return
    }
    (async () => {
      const tempCreds = await AccountsAPI.getTempCreds(email);
      await signInWithCustomToken(tempCreds);
    })()
  }, [signInMethod, isError, isLoading, email])

  if (isError) {
    return <Navigate to="/error"/>;
  }
  if (isLoading || !signInMethod) {
    return <Spinner/>
  }

  let emailLoginSendTo = "", continueWithEmailClicked = false;
  if (signInMethod === AuthProviderType.Password) {
    continueWithEmailClicked = params.get("continue-with-email") === "true";
    if (!continueWithEmailClicked) {
      emailLoginSendTo = `${location.pathname}?continue-with-email=true`
    }
  }

  return (
    <div data-testid={`existing-user-card-${email}`}>
      <WakeletHeader message={translateKey("account:user.existing.card.heading")}/>
      <UserCard provider={signInMethod} displayName={displayName} email={email}/>

      {continueMessage &&
        <Text.Paragraph className="pt-3 flex items-center justify-center"
                        data-testid={"existing-user-card-continue-message"}>
          {continueMessage}
        </Text.Paragraph>
      }
      <ContinueWithAuthProvider provider={signInMethod}
                                email={email}
                                emailLoginSendTo={emailLoginSendTo}
                                showPasswordOnlyLoginForm={continueWithEmailClicked}/>
    </div>
  );
}
